import { LinkTarget } from '../../../types/pdfjs-dist.type';
import { addLinkAttributes } from '../../../utils/pdfjs-dist.utils';
import { PdfViewerNavigateToPageEvent } from '../+types/pdf-viewer-event.type';
export class PdfJsLinkService {
    constructor(eventBus, pages, externalLinkTarget = LinkTarget.BLANK, externalLinkRel = null) {
        this.eventBus = eventBus;
        this.pages = pages;
        this.externalLinkTarget = externalLinkTarget;
        this.externalLinkRel = externalLinkRel;
        this.pdfDocument = null;
        this.baseUrl = '';
        this.externalLinkEnabled = true;
        this._pagesRefCache = null;
    }
    setDocument(pdfDocument) {
        this.pdfDocument = pdfDocument;
        this._pagesRefCache = Object.create(null);
    }
    get pagesCount() {
        return this.pdfDocument ? this.pdfDocument.numPages : 0;
    }
    get page() {
        return 0;
    }
    set page(value) { }
    get rotation() {
        return 0;
    }
    set rotation(value) { }
    handleShowpadLink(showpadLink) {
        const message = {};
        message.type = 'showpad-asset-link';
        message.data = {
            link: showpadLink
        };
        // TODO put message on eventBus for example new ViewerLinkClickedEvent
        if (window && window.postMessage && !window.ShowpadLib) {
            window.postMessage(JSON.stringify(message), '*');
        }
    }
    goToDestination(dest /*The named, or explicit, PDF destination.*/) {
        return new Promise((resolve, reject) => {
            if (typeof dest === 'string') {
                this.pdfDocument.getDestination(dest).then(destArray => {
                    resolve({
                        namedDest: dest,
                        explicitDest: destArray
                    });
                });
                return;
            }
            resolve({
                namedDest: '',
                explicitDest: dest
            });
        }).then((data) => {
            if (!(data.explicitDest instanceof Array)) {
                console.error(`PDFLinkService.navigateTo: "${data.explicitDest}" is` + ` not a valid destination array, for dest="${dest}".`);
                return;
            }
            this.goToDestinationHelper(dest, data.namedDest, data.explicitDest);
        });
    }
    goToDestinationHelper(rawDest, namedDest = null, explicitDest) {
        // Dest array looks like that: <page-ref> </XYZ|/FitXXX> <args..>
        const destRef = explicitDest[0];
        let pageNumber;
        if (destRef instanceof Object) {
            pageNumber = this._cachedPageNumber(destRef);
            if (pageNumber === null) {
                // Fetch the page reference if it's not yet available. This could
                // only occur during loading, before all pages have been resolved.
                this.pdfDocument
                    .getPageIndex(destRef)
                    .then(pageIndex => {
                    this.cachePageRef(pageIndex + 1, destRef);
                    this.goToDestinationHelper(rawDest, namedDest, explicitDest);
                })
                    .catch(() => {
                    console.error(`PDFLinkService.goToDestinationHelper: "${destRef}" is not ` + `a valid page reference, for dest="${rawDest}".`);
                });
                return;
            }
        }
        else if (Number.isInteger(destRef)) {
            pageNumber = destRef + 1;
        }
        else {
            console.error(`PDFLinkService.goToDestinationHelper: "${destRef}" is not ` + `a valid destination reference, for dest="${rawDest}".`);
            return;
        }
        if (!pageNumber || pageNumber < 1 || pageNumber > this.pagesCount) {
            console.error(`PDFLinkService.goToDestinationHelper: "${pageNumber}" is not ` + `a valid page number, for dest="${rawDest}".`);
            return;
        }
        // TODO dispatch generic event new PdfJsLinkServiceNavigateToPage etc also emit pageNumber to remove dep of this.pages
        if (pageNumber && this.pages.has(pageNumber)) {
            const pageId = this.pages.get(pageNumber).id;
            this.eventBus.dispatch(new PdfViewerNavigateToPageEvent({ pageId }));
        }
    }
    cachePageRef(pageNum, pageRef) {
        let refStr = pageRef.num + ' ' + pageRef.gen + ' R';
        this._pagesRefCache[refStr] = pageNum;
    }
    _cachedPageNumber(pageRef) {
        let refStr = pageRef.num + ' ' + pageRef.gen + ' R';
        return (this._pagesRefCache && this._pagesRefCache[refStr]) || null;
    }
    getDestinationHash(dest) {
        if (typeof dest === 'string') {
            return this.getAnchorUrl('#' + window.escape(dest));
        }
        if (dest instanceof Array) {
            let str = JSON.stringify(dest);
            return this.getAnchorUrl('#' + window.escape(str));
        }
        return this.getAnchorUrl('');
    }
    /**
     * Prefix the full url on anchor links to make sure that links are resolved
     * relative to the current URL instead of the one defined in <base href>.
     * @param {String} anchor The anchor hash, including the #.
     * @returns {string} The hyperlink to the PDF object.
     */
    getAnchorUrl(anchor) {
        return (this.baseUrl || '') + anchor;
    }
    setHash(hash) { }
    executeNamedAction(action) { }
    onFileAttachmentAnnotation({ id, filename, content }) { }
    /**
     * Wrapper around the `addLinkAttributes` helper function.
     * @param {HTMLAnchorElement} link
     * @param {string} url
     * @param {boolean} [newWindow]
     */
    addLinkAttributes(link, url, newWindow = false) {
        addLinkAttributes(link, {
            url,
            target: newWindow ? LinkTarget.BLANK : this.externalLinkTarget,
            rel: this.externalLinkRel,
            enabled: this.externalLinkEnabled
        });
    }
    /**
     * @param {number|string} val - The page number, or page label.
     */
    goToPage(val) { }
    /**
     * @param {number} pageNumber
     */
    isPageVisible(pageNumber) {
        return true;
    }
    /**
     * @param {number} pageNumber
     */
    isPageCached(pageNumber) {
        return true;
    }
}
//# sourceMappingURL=pdfjs-link.service.js.map